import api from './api';

export const leadGenerationService = {
  // Get all lead generation transactions
  getAllLeads: async (params = {}) => {
    try {
      const response = await api.get('/lead-generation', { params });
      return response.data;
    } catch (error) {
      console.error('Error getting lead generation transactions:', error);
      throw error;
    }
  },

  // Get lead by ID
  getLeadById: async (id) => {
    try {
      const response = await api.get(`/lead-generation/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting lead:', error);
      throw error;
    }
  },

  // Create new lead
  createLead: async (leadData) => {
    try {
      const response = await api.post('/lead-generation', leadData);
      return response.data;
    } catch (error) {
      console.error('Error creating lead:', error);
      throw error;
    }
  },

  // Update lead
  updateLead: async (id, leadData) => {
    try {
      const response = await api.put(`/lead-generation/${id}`, leadData);
      return response.data;
    } catch (error) {
      console.error('Error updating lead:', error);
      throw error;
    }
  },

  // Delete lead
  deleteLead: async (id) => {
    try {
      const response = await api.delete(`/lead-generation/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting lead:', error);
      throw error;
    }
  },

  // Bulk delete leads
  bulkDeleteLeads: async (leadIds) => {
    try {
      const response = await api.delete('/lead-generation/bulk', {
        data: { leadIds }
      });
      return response.data;
    } catch (error) {
      console.error('Error bulk deleting leads:', error);
      throw error;
    }
  },

  // Get lead statistics
  getLeadStats: async () => {
    try {
      const response = await api.get('/lead-generation/stats');
      return response.data;
    } catch (error) {
      console.error('Error getting lead stats:', error);
      throw error;
    }
  },

  // Get leads by status
  getLeadsByStatus: async (status) => {
    try {
      const response = await api.get(`/lead-generation/status/${status}`);
      return response.data;
    } catch (error) {
      console.error('Error getting leads by status:', error);
      throw error;
    }
  },

  // Get leads by source
  getLeadsBySource: async (source) => {
    try {
      const response = await api.get(`/lead-generation/source/${source}`);
      return response.data;
    } catch (error) {
      console.error('Error getting leads by source:', error);
      throw error;
    }
  },

  // Get leads by priority
  getLeadsByPriority: async (priority) => {
    try {
      const response = await api.get(`/lead-generation/priority/${priority}`);
      return response.data;
    } catch (error) {
      console.error('Error getting leads by priority:', error);
      throw error;
    }
  },

  // Get leads by assigned user
  getLeadsByAssignedUser: async (assignedTo) => {
    try {
      const response = await api.get(`/lead-generation/assigned/${assignedTo}`);
      return response.data;
    } catch (error) {
      console.error('Error getting leads by assigned user:', error);
      throw error;
    }
  },

  // Get leads requiring follow-up
  getLeadsRequiringFollowUp: async () => {
    try {
      const response = await api.get('/lead-generation/follow-up/required');
      return response.data;
    } catch (error) {
      console.error('Error getting leads requiring follow-up:', error);
      throw error;
    }
  }
};
